import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
export function ProblemSection() {
  const problems = ['Mirás tutoriales sueltos y nunca entendés el proceso completo', 'No sabés qué materiales comprar', 'Te confundís con las agujas, telas e hilos', 'Intentás hacerlo sola y abandonás', 'No sabés cuánto cobrar por tus trabajos', 'Querés vender pero no sabés por dónde empezar'];
  return <section className="py-8 md:py-12 px-4 bg-white" data-id="element-256">
      <div className="max-w-3xl mx-auto" data-id="element-257">
        <h2 className="font-heading text-2xl md:text-3xl text-brand-dark font-bold text-center mb-4 leading-tight" data-id="element-258">
          ¿Cuánto tiempo más vas a seguir mirando videos sin aprender realmente?
        </h2>

        <div className="text-base text-brand-text space-y-1 text-center mb-6" data-id="element-259">
          <p data-id="element-260">Te encantan las manualidades.</p>
          <p data-id="element-261">Te gustaría crear piezas hermosas con tus propias manos.</p>
          <p data-id="element-262">Incluso quizás venderlas.</p>
          <p className="font-semibold mt-2 text-brand-dark" data-id="element-263">
            Pero seguramente te pasa esto:
          </p>
        </div>

        <div className="bg-red-50 rounded-2xl p-5 border border-red-100 mb-5" data-id="element-264">
          <ul className="space-y-2.5" data-id="element-265">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3 text-brand-dark" data-id="element-266">
                <CloseIcon className="text-red-500 mt-0.5 shrink-0" fontSize="small" data-id="element-267" />
                <span className="font-medium text-sm md:text-base" data-id="element-268">
                  {problem}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="text-center" data-id="element-269">
          <p className="text-lg font-bold text-brand-dark mb-1" data-id="element-270">
            No es falta de talento.
          </p>
          <p className="text-lg font-bold text-brand-pink" data-id="element-271">
            Es falta de un método claro.
          </p>
        </div>
      </div>
    </section>;
}